<template>
    <span
      :class="{[props.class] : true, [props.type] : true, 'disabled' : props.loading || props.disabled}"
      :tabindex= "tabindex"
      role= "button"
      @click="onClick"
    >
        <i v-if="props.loading && !props.disabled"
          class='fas fa-spinner fa-spin'
          aria-hidden="true">
        </i>

        <i v-else-if="props.icon"
          :class='props.icon'
          aria-hidden="true">
        </i>

        <small v-if="props.text">
          {{Language.say(props.text)}}
        </small>

        <small v-if="props.badge">
          {{Language.say(props.badge)}}
        </small>
    </span>
</template>

<script setup>
  import {defineProps} from "vue";
  import Language      from '@/js/Shared/Language/Language.js';
  import ClientLoggingControllerSingleton from "@/js/Webmail/ClientLogging/ClientLoggingController";
  import GTMAnalyticsControllerSingleton from "@/js/Webmail/Analytics/GTMAnalyticsController";

  const props = defineProps({
    text : {
      default : null,
      type    : String,
    },

    badge : {
      default: null,
    },

    icon: {
      type    : String,
      default : null
    },

    class: {
      type    : String,
      default : '',
    },

    type: {
      type    : String,
      default : 'button',
    },

    loading : {
      default: false,
    },

    disabled : {
        default : false,
    },

    tabindex : {
      default: 0
    },

    gtm : {
      default : null,
    }
  })

  const onClick = (event) => {
    ClientLoggingControllerSingleton.addEntry({
      type: 'action-button-click',
      text: props.text || event.currentTarget.getAttribute('data-text') || 'no-text',
    });

    if (props.gtm) {
      GTMAnalyticsControllerSingleton.postTrackerLink(
        props.gtm.module,
        props.gtm.feature,
        props.gtm.block,
        props.gtm.action
      );
    }
  }
</script>